import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function BulletTrainFill(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M4.859 5.982A5 5 0 019.754 2h4.467a5 5 0 014.903 4.02l1.639 8.196A4 4 0 0116.84 19H7.07a4 4 0 01-3.917-4.814L4.86 5.982zM5 21a1 1 0 011-1h12a1 1 0 110 2H6a1 1 0 01-1-1zM8.37 6.962A1.75 1.75 0 0110.098 5.5H13.8c.803 0 1.422.547 1.617 1.326l.56 2.242a.75.75 0 01-.727.932h-6.5a.75.75 0 01-.74-.873l.36-2.165zM12 16a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    clipRule: "evenodd"
  }));
}

export default BulletTrainFill;